import React from "react";
import { useDispatch } from "react-redux";
import "./StudentProposal.scss";

import StatusStudentInfo from "../generalComponents/StatusStudentInfo";
import StudentFlag from "../generalComponents/StudentFlag";
import { images } from "../../constants";
import { removeStudentFromProposal } from "../../actions/proposal";

const StudentProposal = ({ studentSelected }) => {
  const dispatch = useDispatch();

  const handleDeleteUser = () => {
    dispatch(removeStudentFromProposal());
  };
  return (
    <div className="choose-student__content--item">
      <div className="student-content__name">
        <div className="content__information">
          <div className="content__information--info">
            <h2 className="title-gray-bold-26">
              {studentSelected.studentname}
            </h2>
            <h2 className="title-gray-reg-26">{studentSelected.middlename}</h2>
            <h2 className="title-gray-reg-26">
              {studentSelected.studentlastname}
            </h2>
          </div>
          <StudentFlag nationality={`${studentSelected.nationality}`} />
        </div>
        <button onClick={handleDeleteUser}>
          <img src={images.IconDelete} alt="" />
        </button>
      </div>

      <div className="student-content__student-info">
        <p className="paragraph-gray-reg-16">Email: {studentSelected.email}</p>
        <p className="paragraph-gray-reg-16">
          Phone: {studentSelected.phone.dial_code}{" "}
          {studentSelected.phone.number}
        </p>
        <StatusStudentInfo status={studentSelected.status} />
      </div>
    </div>
  );
};

export default StudentProposal;
